{
  "organizationLabel": "組織 :",
  "profileDropdownAccountInfoItem": "アカウント情報（内部）",
  "profileDropdownAccountSettingsHeader": "アカウント設定",
  "profileDropdownProductSettingsHeader": "製品設定",
  "profileDropdownUserSettingsItem": "環境設定",
  "profileLegalNoticesMenuItem": "法律上の注意",
  "signOut": "ログアウト",
  "themeInfoTooltip": "ダークテーマがサポートされていないアプリケーションもあります。",
  "userProfileName": "{lastName} {firstName}",
  "userThemeSwitchLabel": "ダークテーマ"
}
